module.exports = __webpack_public_path__ + "img/icon_map_8_on_110.e93ee987.png";